<script>
import Swal from "sweetalert2";
export default {
    props: {
        data: Object,
    },
    methods: {
        openDocument(x) {
            this.readFile(x.id)
        },
        searchDocuChild(row, search){
            let data = row.files;
            if (search.trim() != "" && search) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(search.toUpperCase());
                });
            }
            return data;
        },
        removeFile(id, parent){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("filemanager/DeleteFile", id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = parent.files.findIndex(x => x.id == id);
                            parent.files.splice(index, 1);
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            })
        }
    }
}
</script>
<template>
    <div>
        <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="d-flex">
                <p
                    class="mb-0"
                    v-if="!data.attachmentLoading && data.rfqFiles.length == 0"
                >
                    <i>No documents found</i>
                </p>
                <p
                    class="mb-0"
                    v-if="data.attachmentLoading"
                >
                    <i class="font-size-15">Loading...</i
                    >
                </p>
                <input
                    v-if="!data.attachmentLoading && data.rfqFiles.length > 0"
                    type="search"
                    class="form-control"
                    v-model="data.fileSearch"
                    @input="searchDocu(x)"
                    placeholder="Search Documents..."
                />
            </div>
            <!-- <div class="">
                <a
                    href="javascript:void(0);"
                    class="
                        text-primary
                        border-primary
                        border
                        p-2
                    "
                    :id="`submitted-document${data.id}`"
                    @click="
                        data.addDocu = true
                    "
                    ><i
                        class="
                            bx
                            bx-plus
                        "
                    ></i
                    >Upload
                    Documents</a
                >
                <upload-popover
                    :option="
                        uploadOptions
                    "
                    :sourceId="
                        data.id
                    "
                    @uploaded="
                        uploadedSubmitted(
                            $event,
                            data.id
                        )
                    "
                    :showPV="
                        data.addDocu
                    "
                    @closePopover="
                        data.addDocu = false
                    "
                    :dzId="`dropzone-submitted${data.id}`"
                    :pvId="`submitted-document${data.id}`"
                ></upload-popover>
            </div> -->
        </div>
        <div class="mt-2">
            <div v-for="w in data.rfqFiles" :key="w.title" class="mb-3">
                <h4>{{w.title}}</h4>
                <b-row>
                    <b-col
                        sm="3"
                        v-for="(y, index) in searchDocuChild(w, data.fileSearch)"
                        :key="y.id"
                        class="mb-2"
                    >
                        <div
                            class="position-relative cursor-pointer"
                            :style="`z-index: ${searchDocuChild(w, data.fileSearch).length - index}`"
                        >
                            <div class="border p-3">
                                <div>
                                    <div class="float-end ms-2">
                                        <b-dropdown
                                            id="dropdown-dropleft"
                                            right
                                            variant="link"
                                            toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                            menu-class="dropdown-menu-end"
                                            no-caret
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-dots-horizontal"></i>
                                            </template>
                                            <b-dropdown-item
                                                @click="openDocument(y)"
                                                ><i
                                                    class="
                                                        bx
                                                        bx-link-external
                                                        me-1
                                                    "
                                                ></i
                                                >Open</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                variant="danger"
                                                @click="removeFile(y.id, w)"
                                                ><i
                                                    class="
                                                        bx
                                                        bx-trash
                                                        me-1
                                                    "
                                                ></i
                                                >Remove</b-dropdown-item
                                            >
                                        </b-dropdown>
                                    </div>
                                    <div
                                        class="
                                            avatar-xs
                                            me-3
                                            mb-2
                                        "
                                        @click="
                                            openDocument(
                                                y
                                            )
                                        "
                                    >
                                        <div
                                            class="
                                                avatar-title
                                                bg-transparent
                                                rounded
                                            "
                                        >
                                            <i
                                                v-if="
                                                    y.fileType.includes(
                                                        'image'
                                                    )
                                                "
                                                class="
                                                    mdi
                                                    mdi-image
                                                    font-size-24
                                                    text-purple
                                                "
                                            ></i>
                                            <i
                                                v-if="
                                                    y.fileType.includes(
                                                        'application'
                                                    )
                                                "
                                                class="
                                                    mdi
                                                    mdi-file-pdf-outline
                                                    font-size-24
                                                    text-danger
                                                "
                                            ></i>
                                        </div>
                                    </div>
                                    <div
                                        class="d-flex"
                                        @click="openDocument(y)"
                                    >
                                        <div class="overflow-hidden me-auto">
                                            <h5 class="font-size-14 text-truncate mb-1">
                                                {{ y.description }}
                                            </h5>
                                            <p class="text-muted mb-0">
                                                {{formatDateWithTime(new Date( y.dateTimeUploaded))}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row v-if="searchDocuChild(w, data.fileSearch).length == 0 && data.fileSearch">
                    <b-col>Search Not Found</b-col>
                </b-row>
                <div v-if="!w.files.length">
                    <small>No data found...</small>
                </div>
            </div>
        </div>
    </div>
</template>